export type TransferOutDestination = 'factory'

export interface TransferOutRequest {
  pileIds: string[]
  destination: TransferOutDestination
}

const MOCK_DELAY_MS = 1500

export async function mockTransferOut(
  _projectId: string,
  request: TransferOutRequest
): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, MOCK_DELAY_MS))
  if (!request.pileIds.length) {
    throw new Error('No piles selected')
  }
}
